import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class VaultDistributionRecipientType extends Enum {
  static EVERYTHING_TO_MY_SPOUSE = {
    key: 'everything_to_my_spouse',
    get value() {
      return Lang.t('vaultdistributionsetting.everything-to-spouse');
    }
  };

  static EVERYTHING_TO_MY_EXISTING_AND_FUTURE_CHILDREN = {
    key: 'everything_to_my_existing_and_future_children',
    get value() {
      return Lang.t('vaultdistributionsetting.everything-to-future');
    }
  };

  static HALF_TO_MY_SPOUSE_HALF_TO_MY_EXISTING_AND_FUTURE_CHILDREN = {
    key: 'half_to_my_spouse_half_to_my_existing_and_future_children',
    get value() {
      return Lang.t('vaultdistributionsetting.to-and-and');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('guidancestep.other-distribution');
    }
  };
}
